import FragranceMetricsExpressCLT from "./pages/FragranceMetricsExpressCLT";
import UserManagement from "./pages/UserManagement";
import Study from "./pages/Study";
import OverallKpi from "./pages/OverallKpi";
import AgreementKpi from "./pages/AgreementKpi";
import Correlation from "./pages/Correlation";
import FragranceDriver from "./pages/FragranceDriver";
import DriverAnalysis from "./pages/DriverAnalysis";
import ClaimsAnalysis from "./pages/ClaimsAnalysis";
import RespondentSettings from "./pages/RespondentSettings";
import Home from "./pages/Home";
import DriverAnalysisReport from "components/driverAnalysis/DriverAnalysisReport";
import RespondentDashboard from "./pages/RespondentDashboard";
import UserAccessManagement from "./pages/UserAccessManagement";
import JustRightAnalysis from "./pages/JustRightAnalysis";
import DataControlPanel from "./pages/DataControlPanel";
import FragranceMetricsAnalysis from "./pages/FragranceMetricsAnalysis";
import Login from "./pages/Login";
import FragranceMetricsAnalysisCLT from "./pages/FragranceMetricsAnalysisCLT";
import PreferenceAnalysis from "pages/PreferenceAnalysis";
import AgreementKpiAnalysisClt from "./pages/AgreementKpiCLT";
import PreferenceAnalysisExpressCLT from "./pages/PreferenceAnalysisExpressCLT";
import FragranceAssociationCLT from "./pages/FragranceAssociationCLT";
import TextThemeAnalysis from "./pages/TextThemeAnalysis";
import MatchNetLandingPage from "./pages/MatchNetLandingPage";
import MatchNetLookupPage from "./pages/MatchNetLookupPage";
import MatchNetCrossStudyComparison from "./pages/MatchNetCrossStudyComparison";
import AutoDeckReport from "./pages/AutoDeckReport";

const routes = [
    {
        id: "login",
        pageName: "Login",
        isProtected: false,
        path: "/login",
        element: <Login headerTitle={"Login"} />,
        // errorElement: <ErrorPage />,
    },

    {
        id: "homePage",
        pageName: "Home",
        isProtected: true,
        path: "/",
        element: <Home headerTitle={"Home"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "studies",
        pageName: "Studies",
        isProtected: true,
        path: "/studies",
        element: <Study headerTitle={"Studies"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "respondent-module",
        pageName: "Respondent Module",
        isProtected: true,
        path: "/respondent-module",
        element: <RespondentDashboard headerTitle={"Respondent Module"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "user-management",
        pageName: "User Management",
        isProtected: true,
        path: "/user-management",
        element: <UserManagement headerTitle={"User Management"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "user-access-management",
        pageName: "User Access Management",
        isProtected: true,
        path: "/user-access-management",
        element: <UserAccessManagement headerTitle={"User Access Management"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "overall-analysis",
        pageName: "Overall KPI Analysis",
        isProtected: true,
        path: "/overall-analysis/:page",
        element: <OverallKpi headerTitle={"Overall KPI Analysis"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "text-theme-analysis",
        pageName: "Text Theme Analysis",
        isProtected: true,
        path: "/text-theme-analysis",
        element: <TextThemeAnalysis headerTitle={"Theme Text Analysis"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "agreement-analysis",
        pageName: "Agreement KPI Analysis",
        isProtected: true,
        path: "/agreement-analysis",
        element: <AgreementKpi headerTitle={"Agreement KPI Analysis"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "correlation",
        pageName: "Correlation",
        isProtected: true,
        path: "/correlation",
        element: <Correlation headerTitle={"Correlation"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "fragrance-driver",
        pageName: "Fragrance Driver",
        isProtected: true,
        path: "/fragrance-driver",
        element: <FragranceDriver headerTitle={"Fragrance Driver"} />,
    },
    {
        id: "driver-analysis",
        pageName: "Driver Analysis",
        isProtected: true,
        path: "/driver-analysis",
        element: <DriverAnalysis headerTitle={"Driver Analysis"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "driver-analysis-report",
        pageName: "Driver Analysis",
        isProtected: true,
        path: "/driver-analysis/report/:id",
        element: <DriverAnalysisReport headerTitle={"Driver Analysis Report"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "claims-analysis",
        pageName: "Claims Analysis",
        isProtected: true,
        path: "/claims-analysis",
        element: <ClaimsAnalysis headerTitle={"Claims Analysis"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "respondent-settings",
        pageName: "Respondent Settings",
        isProtected: true,
        path: "/respondent-settings",
        element: <RespondentSettings headerTitle={"Respondent Settings"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "just-right-analysis",
        pageName: "Just Right Analysis",
        isProtected: true,
        path: "/just-right-analysis",
        element: <JustRightAnalysis headerTitle={"Just Right Analysis"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "data-control-panel",
        pageName: "Data Control Panel",
        isProtected: true,
        path: "/data-control-panel/:page?",
        element: <DataControlPanel headerTitle={"Data Control Panel"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "fragrance-metrics-analysis",
        pageName: "Fragrance Metrics Analysis",
        isProtected: true,
        path: "/fragrance-metrics-analysis/",
        element: <FragranceMetricsAnalysis headerTitle={"Fragrance Metrics Analysis"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "fragrance-metrics-analysis-express-clt",
        pageName: "FragranceMatricsExpressCLT",
        isProtected: true,
        path: "/fragrance-metrics-analysis/express-clt/:page",
        element: <FragranceMetricsExpressCLT headerTitle={"Fragrance Metrics Analysis"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "fragrance-metrics-analysis-clt",
        pageName: "Fragrance Metrics Analysis CLT",
        isProtected: true,
        path: "/fragrance-metrics-analysis/clt/:page",
        element: <FragranceMetricsAnalysisCLT headerTitle={"Fragrance Metrics Analysis"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "preference-analysis",
        pageName: "Preference Analysis",
        isProtected: true,
        path: "/preference-analysis",
        element: <PreferenceAnalysis headerTitle={"Preference Analysis"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "preference-analysis-express-clt",
        pageName: "Preference Analysis Express CLT",
        isProtected: true,
        path: "/product-preference-analysis",
        element: <PreferenceAnalysisExpressCLT headerTitle={"Product Preference Analysis"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "agreement-analysis-clt",
        pageName: "Agreement Kpi Analysis",
        isProtected: true,
        path: "/agreement-analysis/clt",
        element: <AgreementKpiAnalysisClt headerTitle={"Agreement KPI Analysis"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "fragrance-association-clt",
        pageName: "Fragrance Association",
        isProtected: true,
        path: "/fragrance-association/clt",
        element: <FragranceAssociationCLT headerTitle={"Fragrance Association"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "match-net",
        pageName: "Match Net",
        isProtected: true,
        path: "/match-net",
        element: <MatchNetLandingPage headerTitle={"Match Net"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "match-net-lookup",
        pageName: "Match Net Lookup Table",
        isProtected: true,
        path: "/match-net/lookup",
        element: <MatchNetLookupPage headerTitle={"MatchNet Lookup Table"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "match-net-cross-study-comparison",
        pageName: "Match Net Cross Study Comparison",
        isProtected: true,
        path: "/match-net/cross-study-comparison",
        element: <MatchNetCrossStudyComparison headerTitle={"MatchNet - Cross Study Comparison"} />,
        // errorElement: <ErrorPage />,
    },
    {
        id: "autodeck-report",
        pageName: "AutoDeck Report",
        isProtected: true,
        path: "/autodeck-report",
        element: <AutoDeckReport headerTitle={"AutoDeck Report"} />,
        // errorElement: <ErrorPage />,
    },
];

export default routes;
